var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (classname, headerImg, headerImgMobile, styles) {
      pug_html = pug_html + "\u003Cpicture\u003E";
if (headerImgMobile) {
pug_html = pug_html + "\u003Csource" + (pug.attr("srcset", headerImgMobile.src, true, true)+" media=\"(max-width: 767px)\"") + "\u002F\u003E";
}
pug_html = pug_html + "\u003Csource" + (pug.attr("srcset", headerImg.src, true, true)+" media=\"(min-width: 768px)\"") + "\u002F\u003E\u003Cimg" + (pug.attr("class", pug.classes([classname], [true]), false, true)+pug.attr("src", headerImg.src, true, true)+pug.attr("width", headerImg.width, true, true)+pug.attr("height", headerImg.height, true, true)+pug.attr("alt", headerImg.alt, true, true)+pug.attr("style", pug.style((styles) ? styles : false), true, true)) + "\u002F\u003E\u003C\u002Fpicture\u003E";
    }.call(this, "classname" in locals_for_with ?
        locals_for_with.classname :
        typeof classname !== 'undefined' ? classname : undefined, "headerImg" in locals_for_with ?
        locals_for_with.headerImg :
        typeof headerImg !== 'undefined' ? headerImg : undefined, "headerImgMobile" in locals_for_with ?
        locals_for_with.headerImgMobile :
        typeof headerImgMobile !== 'undefined' ? headerImgMobile : undefined, "styles" in locals_for_with ?
        locals_for_with.styles :
        typeof styles !== 'undefined' ? styles : undefined));
    ;;return pug_html;}

module.exports = template